import React from 'react';
import { RotatingLines } from 'react-loader-spinner';

const TableLoader = () => {
  return (
    <div className='loader-overlay'>
      <RotatingLines strokeColor='#fdbf47' strokeWidth='5' animationDuration='0.75' width={50} visible={true} />
    </div>
  );
};

export default TableLoader;
